var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeM(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 18.5H9V13.5C9 13.2167 9.09583 12.9792 9.2875 12.7875C9.47917 12.5958 9.71667 12.5 10 12.5H14C14.2833 12.5 14.5208 12.5958 14.7125 12.7875C14.9042 12.9792 15 13.2167 15 13.5V18.5H18V9.5L12 5L6 9.5V18.5ZM4 18.5V9.5C4 9.18333 4.07083 8.88333 4.2125 8.6C4.35417 8.31667 4.55 8.08333 4.8 7.9L10.8 3.4C11.15 3.13333 11.55 3 12 3C12.45 3 12.85 3.13333 13.2 3.4L19.2 7.9C19.45 8.08333 19.6458 8.31667 19.7875 8.6C19.9292 8.88333 20 9.18333 20 9.5V18.5C20 19.05 19.8042 19.5208 19.4125 19.9125C19.0208 20.3042 18.55 20.5 18 20.5H14C13.7167 20.5 13.4792 20.4042 13.2875 20.2125C13.0958 20.0208 13 19.7833 13 19.5V14.5H11V19.5C11 19.7833 10.9042 20.0208 10.7125 20.2125C10.5208 20.4042 10.2833 20.5 10 20.5H6C5.45 20.5 4.97917 20.3042 4.5875 19.9125C4.19583 19.5208 4 19.05 4 18.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeM);
export default __webpack_public_path__ + "static/media/home-m.e2eee41f4fca26b843ad2f0cc70c0519.svg";
export { ForwardRef as ReactComponent };